import * as VueDemi from 'vue-demi';
var Helper = /** @class */ (function () {
    function Helper() {
        this.Return = VueDemi.defineComponent({});
    }
    return Helper;
}());
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/types/index.js
// module id = null
// module chunks = 